/**
 * Validate input timestamp
 * @param {string} savedTimestampString
 * @returns {boolean} true if saved timestamp in cookie >= current timestamp
 */
const isValidTimestamp = function(savedTimestampString) {
  if (savedTimestampString) {
    const savedTime = Number(savedTimestampString);
    if (isNaN(savedTime) || savedTime === 0) {
      return false;
    } // invalid
    const thisTime = Number(new Date());
    return savedTime >= thisTime;
  }
  return false;
};

export default isValidTimestamp;
